__turbopack_context__.v({
  "card": "Settlement-module-scss-module__8ihYyG__card",
  "custom-columns-container": "Settlement-module-scss-module__8ihYyG__custom-columns-container",
  "description": "Settlement-module-scss-module__8ihYyG__description",
  "description-text": "Settlement-module-scss-module__8ihYyG__description-text",
  "explanations": "Settlement-module-scss-module__8ihYyG__explanations",
  "has-green-border": "Settlement-module-scss-module__8ihYyG__has-green-border",
  "hero": "Settlement-module-scss-module__8ihYyG__hero",
  "settlement": "Settlement-module-scss-module__8ihYyG__settlement",
  "title": "Settlement-module-scss-module__8ihYyG__title",
});
